import { ContactStateSettingsService } from '@/services';
import type { ContactStateSettingsConfig_Input as ContactStateSettingsConfig } from '@/services';

export type { ContactStateSettingsConfig };
export type { CustomStateSpec } from '@/services';
export type { StateAction } from '@/services';
export type { StateActionResponse } from '@/services';
export type { ContactStateSettingsResponse as ContactStateSettingsVersion } from '@/services';

export const getContactStateSettingsList = (campaignId: string) => {
  return ContactStateSettingsService.listContactStateVersionsApiCampaignsCampaignIdContactStateSettingsGet(
    campaignId
  );
};

export const getContactStateSettingsActive = (campaignId: string) => {
  return ContactStateSettingsService.getActiveContactStateSettingsApiCampaignsCampaignIdContactStateSettingsActiveGet(
    campaignId
  );
};

export const getContactStateActions = () => {
  return ContactStateSettingsService.listContactStateActionsApiCampaignsContactStateActionsGet();
};

export const createContactStateSettings = (
  campaignId: string,
  config: ContactStateSettingsConfig
) => {
  return ContactStateSettingsService.createContactStateVersionApiCampaignsCampaignIdContactStateSettingsPost(
    campaignId,
    { config }
  );
};

export const updateContactStateSettings = (
  campaignId: string,
  config: ContactStateSettingsConfig
) => {
  return ContactStateSettingsService.updateActiveContactStateSettingsApiCampaignsCampaignIdContactStateSettingsPut(
    campaignId,
    { config }
  );
};

export const activateContactStateSettings = (
  campaignId: string,
  version: number
) => {
  return ContactStateSettingsService.activateContactStateVersionApiCampaignsCampaignIdContactStateSettingsVersionActivatePost(
    campaignId,
    version
  );
};
